export type ImportRowResult = {
  productCode: string | null;
  length: string | null;
  location: string | null;
  errors: string[];
  rowNumber: number;
};

export type ImportResult = {
  totalRows: number;
  updatedRows: number;
  errors: ImportRowResult[];
};

/** An error answer is an import report only when it carries the rows; a refusal carries none. */
export function isImportResult(data: unknown): data is ImportResult {
  return (
    typeof data === 'object' &&
    data !== null &&
    Array.isArray((data as { errors?: unknown }).errors)
  );
}
